import ZoomOnHover from "./ZoomOnHover.vue";

export default {
 install(Vue, options) {
  Vue.component("zoom-on-hover", ZoomOnHover);
 }
};